import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

const LegendBar = ({ items }) => {
  return (
    <View style={styles.container}>
      {items?.colorBlocks?.map((item, index) => (
        <View key={index} style={styles.item}>
          <View style={[styles.square, { backgroundColor: item.color }]} />
          <Text style={styles.text}>{item.label}</Text>
        </View>
      ))}
      {items?.sampleSize && (
        <>
          {items?.colorBlocks && <View style={styles.divider} />}

          <View style={styles.item}>
            <View style={styles.circle}>
              <View style={styles.semiCircle} />
            </View>
            <Text style={styles.text}>Low sample size &lt; 5</Text>
          </View>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 12
  },
  square: {
    width: 16,
    height: 12,
    marginRight: 6
  },
  text: {
    fontSize: 11,
    color: '#444'
  },
  divider: {
    width: 1,
    height: 20,
    backgroundColor: '#ccc',
    marginHorizontal: 12
  },
  circle: {
    position: 'relative',
    width: 12,
    height: 12,
    borderRadius: '50%',
    border: '1.5px solid #D32F2F',
    overflow: 'hidden',
    flexShrink: 0,
    marginRight: 6
  },
  semiCircle: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '50%',
    backgroundColor: '#D32F2F'
  }
});

export default LegendBar;
